import { GetGeoSearchResponse } from './types';

const RIO_CLIENT_KEY = process.env.RIO_CLIENT_KEY ?? '';
const RIO_BASE_URL = process.env.RIO_BASE_URL ?? '';
const RIO_DID = process.env.RIO_DID ?? '';

const rio = {
  getStoresNearZIPCode: async (param: {
    ZIPCode: string;
  }): Promise<GetGeoSearchResponse> => {
    if (!RIO_CLIENT_KEY) {
      // eslint-disable-next-line no-console
      console.error('RIO_CLIENT_KEY is not set');
      return {};
    }

    if (!param.ZIPCode) {
      // eslint-disable-next-line no-console
      console.error('ZIPCode is required to get stores');
      return {};
    }

    const url = `${RIO_BASE_URL}/lookup?mode=radius&did=${RIO_DID}&lookup=${param.ZIPCode}`;
    const headers = {
      'Content-Type': 'application/json',
      'X-API-KEY': RIO_CLIENT_KEY,
    };

    const getStoresNearZIPCodeResponse = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (!getStoresNearZIPCodeResponse.ok) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch stores near ZIP code from RIO');
      return {};
    }

    const storesData =
      (await getStoresNearZIPCodeResponse.json()) as GetGeoSearchResponse;

    // Call the RIO API to get stores near the ZIP code
    return storesData;
  },

  getStoresWithProductAvailableNearZIPCode: async (param: {
    ZIPCode: string;
    rioProductId: string;
  }): Promise<GetGeoSearchResponse> => {
    if (!RIO_CLIENT_KEY) {
      // eslint-disable-next-line no-console
      console.error('RIO_CLIENT_KEY is not set');
      return {};
    }

    if (!param.ZIPCode) {
      // eslint-disable-next-line no-console
      console.error('ZIPCode is required to get stores');
      return {};
    }

    const url = `${RIO_BASE_URL}/lookup?mode=radius&did=${RIO_DID}
&lookup=${param.ZIPCode}&radius=25&meta=true
&filter=specialties_${param.rioProductId}=1`;

    const headers = {
      'Content-Type': 'application/json',
      'X-API-KEY': RIO_CLIENT_KEY,
    };

    const getStoresNearZIPCodeResponse = await fetch(url, {
      method: 'GET',
      headers,
    });

    if (!getStoresNearZIPCodeResponse.ok) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch stores near ZIP code from RIO');
      return {};
    }

    const storesData =
      (await getStoresNearZIPCodeResponse.json()) as GetGeoSearchResponse;

    // Call the RIO API to get stores near the ZIP code
    return storesData;
  },
};

export default rio;
